module.exports = __webpack_public_path__ + "static/img/simon.af181c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simon.jpg
// module id = SJCn
// module chunks = 1